<section class="content missing-punch-page">
  <div class="content-block">
    <app-breadcrumb [title]="'missingPunchesCatalog.breadcrumb.title' | translate"
                    [items]="['missingPunchesCatalog.breadcrumb.section' | translate]"
                    [active_item]="'missingPunchesCatalog.breadcrumb.title' | translate" />

    <div class="missing-punch-filters">
      @if (companies.length > 1) {
      <app-company-select class="missing-punch-filter" [records]="companies"
                          [value]="filters.companiesRecordId" [includeAll]="true"
                          [label]="'orgUnitsCatalog.fields.company' | translate"
                          [placeholder]="'missingPunchesCatalog.filters.allCompanies' | translate"
                          [allLabel]="'missingPunchesCatalog.filters.allCompanies' | translate"
                          (valueChange)="filters.companiesRecordId = $event; onCompanyChanged()" />
      }
      <app-org-unit-tree-select class="missing-punch-filter"
                                [units]="orgUnits"
                                [value]="filters.orgUnitId"
                                [placeholder]="'missingPunchesCatalog.filters.allOrgUnits' | translate"
                                [searchPlaceholder]="'employeesCatalog.orgUnitPicker.searchPlaceholder' | translate"
                                (valueChange)="filters.orgUnitId = $event; onOrgUnitChanged()" />
      <mat-form-field class="missing-punch-filter" appearance="outline" subscriptSizing="dynamic">
        <mat-icon matPrefix>badge</mat-icon>
        <input matInput [placeholder]="'missingPunchesCatalog.filters.employee' | translate" [ngModel]="employeeSearchText"
               (ngModelChange)="onEmployeeInput($event)" [matAutocomplete]="employeeAutocomplete">
        <mat-autocomplete #employeeAutocomplete="matAutocomplete" [displayWith]="displayEmployee" (optionSelected)="onEmployeeSelected($event)">
          @for (employee of employees; track employee.employeeId) { <mat-option [value]="employee">{{ displayEmployee(employee) }}</mat-option> }
        </mat-autocomplete>
      </mat-form-field>
      <div class="missing-punch-week">
        <button mat-icon-button type="button" (click)="changeWeek(-1)" [attr.aria-label]="'missingPunchesCatalog.actions.previousWeek' | translate"><mat-icon>chevron_left</mat-icon></button>
        <app-date-time-picker-field class="missing-punch-date" [label]="'missingPunchesCatalog.filters.week' | translate"
                                    [value]="filters.weekDate" mode="date" (valueChange)="onWeekDateChanged($event)" />
        <button mat-icon-button type="button" (click)="changeWeek(1)" [attr.aria-label]="'missingPunchesCatalog.actions.nextWeek' | translate"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div class="missing-punch-actions">
        <button mat-icon-button class="refresh" type="button" (click)="refresh()" [disabled]="isLoading" [attr.aria-label]="'common.refresh' | translate"><mat-icon [class.spinning]="isLoading">refresh</mat-icon></button>
        <button mat-icon-button class="clear" type="button" (click)="clearFilters()" [attr.aria-label]="'common.clearFilters' | translate"><mat-icon>filter_alt_off</mat-icon></button>
      </div>
    </div>

    <div class="missing-punch-card">
      @if (isLoading) {
        <app-loading-state [overlay]="false" [message]="'missingPunchesCatalog.loading' | translate" />
      } @else if (!rows.length) {
        <div class="missing-punch-empty"><span><mat-icon>task_alt</mat-icon></span><h3>{{ 'missingPunchesCatalog.empty.title' | translate }}</h3><p>{{ 'missingPunchesCatalog.empty.description' | translate }}</p></div>
      } @else {
        <div class="missing-punch-scroll">
          <table>
            <thead><tr>
              <th class="employee">{{ 'missingPunchesCatalog.table.employeeAndDate' | translate }}</th>
              <th class="timeline-heading">{{ 'missingPunchesCatalog.table.timeline' | translate }}</th>
              <th class="action"></th>
            </tr></thead>
            <tbody>
              @for (row of rows; track row.result.attendanceResultId) {
                <tr (dblclick)="viewResult(row)">
                  <td class="employee">
                    <div class="employee-cell">
                      <span>{{ row.employeeName.charAt(0) }}</span>
                      <div>
                        <strong>{{ row.employeeName }}</strong>
                        <small>{{ row.employeeNumber }} · {{ row.orgUnitName }}</small>
                        <em><mat-icon>calendar_today</mat-icon>{{ workDate(row) }}</em>
                      </div>
                    </div>
                  </td>
                  <td class="timeline-cell">
                    <div class="punch-timeline">
                      @for (item of timelineSlots; track item.slot; let last = $last) {
                        <div class="timeline-step" [class.timeline-step--missing]="isMissing(row, item.slot)" [class.timeline-step--empty]="!punchTime(row, item.slot) && !isMissing(row, item.slot)">
                          <span class="timeline-step__label">{{ ('missingPunchesCatalog.table.' + item.labelKey) | translate }}</span>
                          @if (punchTime(row, item.slot); as time) {
                            <span class="punch-ok"><mat-icon>check</mat-icon><strong>{{ time }}</strong></span>
                          } @else if (isMissing(row, item.slot)) {
                            <button class="punch-missing" type="button" [disabled]="!canCreatePunch"
                                (click)="$event.stopPropagation(); addMissingPunch(row, item.slot)"
                                [attr.aria-label]="'missingPunchesCatalog.manualPunch.addAria' | translate">
                              <mat-icon>add</mat-icon>
                              <span>{{ 'missingPunchesCatalog.status.missing' | translate }}</span>
                              @if (canCreatePunch) { <small>{{ 'missingPunchesCatalog.manualPunch.register' | translate }}</small> }
                            </button>
                          } @else {
                            <span class="punch-empty">—</span>
                          }
                        </div>
                        @if (!last) { <span class="timeline-connector" [class.timeline-connector--alert]="isMissing(row, item.slot)"></span> }
                      }
                    </div>
                  </td>
                  <td class="action">
                    <button mat-stroked-button type="button" (click)="$event.stopPropagation(); viewResult(row)" [attr.aria-label]="'missingPunchesCatalog.actions.view' | translate">
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <mat-paginator [length]="totalItems" [pageIndex]="currentPage - 1" [pageSize]="pageSize" [pageSizeOptions]="[15, 25, 50]" showFirstLastButtons (page)="onPageChange($event)" />
      }
    </div>
  </div>
</section>
